// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"ClUeFeG8S4o-_IdkOwhu1","checkbox__input":"bLOVeQ4LMHldsfUPIy8ST","checkbox__label":"MwbEntwB72oLWE9oWhjsU"};